/* tslint:disable */
/* eslint-disable */
/**
 * GrowIntel API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Areas with cities schema.
 * @export
 * @interface AreaWithCity
 */
export interface AreaWithCity {
    /**
     * 
     * @type {string}
     * @memberof AreaWithCity
     */
    'area': string;
    /**
     * 
     * @type {string}
     * @memberof AreaWithCity
     */
    'city': string;
}
/**
 * Avg price by month schema.
 * @export
 * @interface AvgPriceByMonth
 */
export interface AvgPriceByMonth {
    /**
     * 
     * @type {string}
     * @memberof AvgPriceByMonth
     */
    'scrape_month': string;
    /**
     * 
     * @type {number}
     * @memberof AvgPriceByMonth
     */
    'avg_price': number | null;
}
/**
 * Branch schema.
 * @export
 * @interface Branch
 */
export interface Branch {
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'aggregator': string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'country_code': string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'scrape_month': string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'brand_name': string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'branch_id': string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'branch_name': string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'area': string | null;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'latitude': string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'longitude': string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'branch_image': string | null;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    'cuisines': string;
    /**
     * 
     * @type {number}
     * @memberof Branch
     */
    'delivery_time': number | null;
    /**
     * 
     * @type {number}
     * @memberof Branch
     */
    'rating_score': number | null;
    /**
     * 
     * @type {number}
     * @memberof Branch
     */
    'rating_count': number | null;
    /**
     * 
     * @type {number}
     * @memberof Branch
     */
    'avg_price': number | null;
    /**
     * 
     * @type {number}
     * @memberof Branch
     */
    'median_price': number | null;
}
/**
 * Brand schema.
 * @export
 * @interface Brand
 */
export interface Brand {
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'aggregator': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'country_code': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'scrape_month': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'brand_name': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'brand_image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'cuisines': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'cities': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'areas': string | null;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'total_branches': number | null;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'total_items': number | null;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'total_rating_count': number | null;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'median_price': number | null;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'avg_price': number | null;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'avg_rating_score': number | null;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'avg_delivery_time': number | null;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'completeness': number | null;
}
/**
 * Cuisine operation benchmark schema.
 * @export
 * @interface CuisineOperationBenchmark
 */
export interface CuisineOperationBenchmark {
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'delivery_time_current': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'delivery_time_comparison': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'min_delivery_time_current': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'max_delivery_time_current': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'min_delivery_time_comparison': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'max_delivery_time_comparison': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'rating_current': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'rating_comparison': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'min_rating_current': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'max_rating_current': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'min_rating_comparison': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'max_rating_comparison': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'menu_price_current': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'menu_price_comparison': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'min_menu_price_current': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'max_menu_price_current': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'min_menu_price_comparison': number | null;
    /**
     * 
     * @type {number}
     * @memberof CuisineOperationBenchmark
     */
    'max_menu_price_comparison': number | null;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * Menu item schema.
 * @export
 * @interface MenuItem
 */
export interface MenuItem {
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'aggregator': string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'country_code': string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'scrape_month': string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'area': string | null;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'cuisines': string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'brand_name': string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'branch_id': string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'branch_name': string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'item_id': string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'item_category': string | null;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'item_name': string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'item_description': string | null;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    'item_image': string | null;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    'item_price': number;
}
/**
 * 
 * @export
 * @interface PaginatedResponseAny
 */
export interface PaginatedResponseAny {
    /**
     * 
     * @type {Array<any>}
     * @memberof PaginatedResponseAny
     */
    'items': Array<any>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseAny
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseAny
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseAny
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseAny
     */
    'total_pages': number;
}
/**
 * 
 * @export
 * @interface PaginatedResponseAreaWithCity
 */
export interface PaginatedResponseAreaWithCity {
    /**
     * 
     * @type {Array<AreaWithCity>}
     * @memberof PaginatedResponseAreaWithCity
     */
    'items': Array<AreaWithCity>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseAreaWithCity
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseAreaWithCity
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseAreaWithCity
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseAreaWithCity
     */
    'total_pages': number;
}
/**
 * 
 * @export
 * @interface PaginatedResponseBranch
 */
export interface PaginatedResponseBranch {
    /**
     * 
     * @type {Array<Branch>}
     * @memberof PaginatedResponseBranch
     */
    'items': Array<Branch>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseBranch
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseBranch
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseBranch
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseBranch
     */
    'total_pages': number;
}
/**
 * 
 * @export
 * @interface PaginatedResponseBrand
 */
export interface PaginatedResponseBrand {
    /**
     * 
     * @type {Array<Brand>}
     * @memberof PaginatedResponseBrand
     */
    'items': Array<Brand>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseBrand
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseBrand
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseBrand
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseBrand
     */
    'total_pages': number;
}
/**
 * 
 * @export
 * @interface PaginatedResponseMenuItem
 */
export interface PaginatedResponseMenuItem {
    /**
     * 
     * @type {Array<MenuItem>}
     * @memberof PaginatedResponseMenuItem
     */
    'items': Array<MenuItem>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseMenuItem
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseMenuItem
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseMenuItem
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseMenuItem
     */
    'total_pages': number;
}
/**
 * 
 * @export
 * @interface PaginatedResponsePopularBrand
 */
export interface PaginatedResponsePopularBrand {
    /**
     * 
     * @type {Array<PopularBrand>}
     * @memberof PaginatedResponsePopularBrand
     */
    'items': Array<PopularBrand>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponsePopularBrand
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponsePopularBrand
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponsePopularBrand
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponsePopularBrand
     */
    'total_pages': number;
}
/**
 * 
 * @export
 * @interface PaginatedResponsePopularMenuItem
 */
export interface PaginatedResponsePopularMenuItem {
    /**
     * 
     * @type {Array<PopularMenuItem>}
     * @memberof PaginatedResponsePopularMenuItem
     */
    'items': Array<PopularMenuItem>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponsePopularMenuItem
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponsePopularMenuItem
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponsePopularMenuItem
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponsePopularMenuItem
     */
    'total_pages': number;
}
/**
 * 
 * @export
 * @interface PaginatedResponseStr
 */
export interface PaginatedResponseStr {
    /**
     * 
     * @type {Array<string>}
     * @memberof PaginatedResponseStr
     */
    'items': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseStr
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseStr
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseStr
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseStr
     */
    'total_pages': number;
}
/**
 * 
 * @export
 * @interface PaginatedResponseUniqueMenuItem
 */
export interface PaginatedResponseUniqueMenuItem {
    /**
     * 
     * @type {Array<UniqueMenuItem>}
     * @memberof PaginatedResponseUniqueMenuItem
     */
    'items': Array<UniqueMenuItem>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseUniqueMenuItem
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseUniqueMenuItem
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseUniqueMenuItem
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponseUniqueMenuItem
     */
    'total_pages': number;
}
/**
 * Popular brand schema.
 * @export
 * @interface PopularBrand
 */
export interface PopularBrand {
    /**
     * 
     * @type {string}
     * @memberof PopularBrand
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PopularBrand
     */
    'brand_name': string;
    /**
     * 
     * @type {string}
     * @memberof PopularBrand
     */
    'brand_image': string | null;
    /**
     * 
     * @type {string}
     * @memberof PopularBrand
     */
    'cuisines': string;
    /**
     * 
     * @type {number}
     * @memberof PopularBrand
     */
    'number_of_branches': number;
    /**
     * 
     * @type {number}
     * @memberof PopularBrand
     */
    'total_ratings': number;
    /**
     * 
     * @type {number}
     * @memberof PopularBrand
     */
    'avg_rating': number;
}
/**
 * Popular menu item schema.
 * @export
 * @interface PopularMenuItem
 */
export interface PopularMenuItem {
    /**
     * 
     * @type {string}
     * @memberof PopularMenuItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PopularMenuItem
     */
    'item_image': string | null;
    /**
     * 
     * @type {number}
     * @memberof PopularMenuItem
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PopularMenuItem
     */
    'average_price': number;
    /**
     * 
     * @type {string}
     * @memberof PopularMenuItem
     */
    'brand_name': string;
    /**
     * 
     * @type {string}
     * @memberof PopularMenuItem
     */
    'city': string | null;
    /**
     * 
     * @type {string}
     * @memberof PopularMenuItem
     */
    'area': string | null;
    /**
     * 
     * @type {string}
     * @memberof PopularMenuItem
     */
    'cuisines': string | null;
    /**
     * 
     * @type {string}
     * @memberof PopularMenuItem
     */
    'scrape_month': string;
}
/**
 * Unique menu item schema.
 * @export
 * @interface UniqueMenuItem
 */
export interface UniqueMenuItem {
    /**
     * 
     * @type {string}
     * @memberof UniqueMenuItem
     */
    'aggregator': string;
    /**
     * 
     * @type {string}
     * @memberof UniqueMenuItem
     */
    'country_code': string;
    /**
     * 
     * @type {string}
     * @memberof UniqueMenuItem
     */
    'scrape_month': string;
    /**
     * 
     * @type {string}
     * @memberof UniqueMenuItem
     */
    'brand_name': string;
    /**
     * 
     * @type {string}
     * @memberof UniqueMenuItem
     */
    'item_category': string | null;
    /**
     * 
     * @type {string}
     * @memberof UniqueMenuItem
     */
    'item_name': string;
    /**
     * 
     * @type {string}
     * @memberof UniqueMenuItem
     */
    'item_description': string | null;
    /**
     * 
     * @type {string}
     * @memberof UniqueMenuItem
     */
    'item_image': string | null;
    /**
     * 
     * @type {number}
     * @memberof UniqueMenuItem
     */
    'item_price': number | null;
    /**
     * 
     * @type {number}
     * @memberof UniqueMenuItem
     */
    'avg_price': number | null;
    /**
     * 
     * @type {number}
     * @memberof UniqueMenuItem
     */
    'min_price': number | null;
    /**
     * 
     * @type {number}
     * @memberof UniqueMenuItem
     */
    'max_price': number | null;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * BranchesApi - axios parameter creator
 * @export
 */
export const BranchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a branch by id.
         * @summary Get Branch
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchBranchesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBranchBranchesIdGet', 'id', id)
            const localVarPath = `/branches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a branch by brand id.
         * @summary Get Branch By Brand Id
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchByBrandIdBranchesBrandBrandIdGet: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBranchByBrandIdBranchesBrandBrandIdGet', 'brandId', brandId)
            const localVarPath = `/branches/brand/{brand_id}`
                .replace(`{${"brand_id"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get branch by name.
         * @summary Get Branch By Name
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [city] 
         * @param {string} [area] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchByNameBranchesSearchGet: async (page?: number, pageSize?: number, name?: string, city?: string, area?: string, cuisine?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/branches/search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (cuisine !== undefined) {
                localVarQueryParameter['cuisine'] = cuisine;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get branches.
         * @summary Get Branches
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchesBranchesGet: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/branches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get closed branches.
         * @summary Get Closed Branches
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosedBranchesBranchesClosedGet: async (page?: number, pageSize?: number, cuisine?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/branches/closed/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (cuisine !== undefined) {
                localVarQueryParameter['cuisine'] = cuisine;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get new branches.
         * @summary Get New Branches
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewBranchesBranchesNewGet: async (page?: number, pageSize?: number, city?: string, areas?: Array<string>, cuisine?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/branches/new/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (areas) {
                localVarQueryParameter['areas'] = areas;
            }

            if (cuisine !== undefined) {
                localVarQueryParameter['cuisine'] = cuisine;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BranchesApi - functional programming interface
 * @export
 */
export const BranchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BranchesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a branch by id.
         * @summary Get Branch
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranchBranchesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Branch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranchBranchesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BranchesApi.getBranchBranchesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a branch by brand id.
         * @summary Get Branch By Brand Id
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranchByBrandIdBranchesBrandBrandIdGet(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBranch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranchByBrandIdBranchesBrandBrandIdGet(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BranchesApi.getBranchByBrandIdBranchesBrandBrandIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get branch by name.
         * @summary Get Branch By Name
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [city] 
         * @param {string} [area] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranchByNameBranchesSearchGet(page?: number, pageSize?: number, name?: string, city?: string, area?: string, cuisine?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBranch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranchByNameBranchesSearchGet(page, pageSize, name, city, area, cuisine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BranchesApi.getBranchByNameBranchesSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get branches.
         * @summary Get Branches
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranchesBranchesGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBranch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranchesBranchesGet(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BranchesApi.getBranchesBranchesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get closed branches.
         * @summary Get Closed Branches
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClosedBranchesBranchesClosedGet(page?: number, pageSize?: number, cuisine?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBranch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClosedBranchesBranchesClosedGet(page, pageSize, cuisine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BranchesApi.getClosedBranchesBranchesClosedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get new branches.
         * @summary Get New Branches
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewBranchesBranchesNewGet(page?: number, pageSize?: number, city?: string, areas?: Array<string>, cuisine?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBranch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewBranchesBranchesNewGet(page, pageSize, city, areas, cuisine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BranchesApi.getNewBranchesBranchesNewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BranchesApi - factory interface
 * @export
 */
export const BranchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BranchesApiFp(configuration)
    return {
        /**
         * Get a branch by id.
         * @summary Get Branch
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchBranchesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Branch> {
            return localVarFp.getBranchBranchesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a branch by brand id.
         * @summary Get Branch By Brand Id
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchByBrandIdBranchesBrandBrandIdGet(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBranch> {
            return localVarFp.getBranchByBrandIdBranchesBrandBrandIdGet(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get branch by name.
         * @summary Get Branch By Name
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [city] 
         * @param {string} [area] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchByNameBranchesSearchGet(page?: number, pageSize?: number, name?: string, city?: string, area?: string, cuisine?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBranch> {
            return localVarFp.getBranchByNameBranchesSearchGet(page, pageSize, name, city, area, cuisine, options).then((request) => request(axios, basePath));
        },
        /**
         * Get branches.
         * @summary Get Branches
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranchesBranchesGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBranch> {
            return localVarFp.getBranchesBranchesGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get closed branches.
         * @summary Get Closed Branches
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosedBranchesBranchesClosedGet(page?: number, pageSize?: number, cuisine?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBranch> {
            return localVarFp.getClosedBranchesBranchesClosedGet(page, pageSize, cuisine, options).then((request) => request(axios, basePath));
        },
        /**
         * Get new branches.
         * @summary Get New Branches
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewBranchesBranchesNewGet(page?: number, pageSize?: number, city?: string, areas?: Array<string>, cuisine?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBranch> {
            return localVarFp.getNewBranchesBranchesNewGet(page, pageSize, city, areas, cuisine, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BranchesApi - object-oriented interface
 * @export
 * @class BranchesApi
 * @extends {BaseAPI}
 */
export class BranchesApi extends BaseAPI {
    /**
     * Get a branch by id.
     * @summary Get Branch
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BranchesApi
     */
    public getBranchBranchesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return BranchesApiFp(this.configuration).getBranchBranchesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a branch by brand id.
     * @summary Get Branch By Brand Id
     * @param {string} brandId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BranchesApi
     */
    public getBranchByBrandIdBranchesBrandBrandIdGet(brandId: string, options?: RawAxiosRequestConfig) {
        return BranchesApiFp(this.configuration).getBranchByBrandIdBranchesBrandBrandIdGet(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get branch by name.
     * @summary Get Branch By Name
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [name] 
     * @param {string} [city] 
     * @param {string} [area] 
     * @param {string} [cuisine] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BranchesApi
     */
    public getBranchByNameBranchesSearchGet(page?: number, pageSize?: number, name?: string, city?: string, area?: string, cuisine?: string, options?: RawAxiosRequestConfig) {
        return BranchesApiFp(this.configuration).getBranchByNameBranchesSearchGet(page, pageSize, name, city, area, cuisine, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get branches.
     * @summary Get Branches
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BranchesApi
     */
    public getBranchesBranchesGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return BranchesApiFp(this.configuration).getBranchesBranchesGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get closed branches.
     * @summary Get Closed Branches
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [cuisine] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BranchesApi
     */
    public getClosedBranchesBranchesClosedGet(page?: number, pageSize?: number, cuisine?: string, options?: RawAxiosRequestConfig) {
        return BranchesApiFp(this.configuration).getClosedBranchesBranchesClosedGet(page, pageSize, cuisine, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get new branches.
     * @summary Get New Branches
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [city] 
     * @param {Array<string>} [areas] 
     * @param {string} [cuisine] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BranchesApi
     */
    public getNewBranchesBranchesNewGet(page?: number, pageSize?: number, city?: string, areas?: Array<string>, cuisine?: string, options?: RawAxiosRequestConfig) {
        return BranchesApiFp(this.configuration).getNewBranchesBranchesNewGet(page, pageSize, city, areas, cuisine, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BrandsApi - axios parameter creator
 * @export
 */
export const BrandsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a brand by name.
         * @summary Get Avg Price By Month
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvgPriceByMonthBrandsAvgPriceByMonthGet: async (city?: string, areas?: Array<string>, cuisine?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/avg-price-by-month/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (areas) {
                localVarQueryParameter['areas'] = areas;
            }

            if (cuisine !== undefined) {
                localVarQueryParameter['cuisine'] = cuisine;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a brand by name.
         * @summary Get Brand
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBrandsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBrandBrandsIdGet', 'id', id)
            const localVarPath = `/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a brand by name.
         * @summary Get Brand By Name
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [city] 
         * @param {string} [area] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandByNameBrandsSearchGet: async (page?: number, pageSize?: number, name?: string, city?: string, area?: string, cuisine?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (cuisine !== undefined) {
                localVarQueryParameter['cuisine'] = cuisine;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a brand list by cuisines.
         * @summary Get Brand Cuisines
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [cuisines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCuisinesBrandsCuisinesGet: async (page?: number, pageSize?: number, cuisines?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/cuisines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (cuisines) {
                localVarQueryParameter['cuisines'] = cuisines;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brands.
         * @summary Get Brands
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsBrandsGet: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a cuisine operation benchmark.
         * @summary Get Cuisine Operation Benchmark
         * @param {string} brandId 
         * @param {string} cuisine 
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuisineOperationBenchmarkBrandsCuisineOperationBenchmarkGet: async (brandId: string, cuisine: string, city?: string, areas?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getCuisineOperationBenchmarkBrandsCuisineOperationBenchmarkGet', 'brandId', brandId)
            // verify required parameter 'cuisine' is not null or undefined
            assertParamExists('getCuisineOperationBenchmarkBrandsCuisineOperationBenchmarkGet', 'cuisine', cuisine)
            const localVarPath = `/brands/cuisine-operation-benchmark/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (brandId !== undefined) {
                localVarQueryParameter['brand_id'] = brandId;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (areas) {
                localVarQueryParameter['areas'] = areas;
            }

            if (cuisine !== undefined) {
                localVarQueryParameter['cuisine'] = cuisine;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get popular brands.
         * @summary Get Popular Brands
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [cuisines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopularBrandsBrandsPopularGet: async (page?: number, pageSize?: number, cuisines?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/popular`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (cuisines !== undefined) {
                localVarQueryParameter['cuisines'] = cuisines;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandsApi - functional programming interface
 * @export
 */
export const BrandsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a brand by name.
         * @summary Get Avg Price By Month
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvgPriceByMonthBrandsAvgPriceByMonthGet(city?: string, areas?: Array<string>, cuisine?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvgPriceByMonth>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvgPriceByMonthBrandsAvgPriceByMonthGet(city, areas, cuisine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandsApi.getAvgPriceByMonthBrandsAvgPriceByMonthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a brand by name.
         * @summary Get Brand
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandBrandsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Brand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandBrandsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandsApi.getBrandBrandsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a brand by name.
         * @summary Get Brand By Name
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [city] 
         * @param {string} [area] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandByNameBrandsSearchGet(page?: number, pageSize?: number, name?: string, city?: string, area?: string, cuisine?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBrand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandByNameBrandsSearchGet(page, pageSize, name, city, area, cuisine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandsApi.getBrandByNameBrandsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a brand list by cuisines.
         * @summary Get Brand Cuisines
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [cuisines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandCuisinesBrandsCuisinesGet(page?: number, pageSize?: number, cuisines?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBrand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandCuisinesBrandsCuisinesGet(page, pageSize, cuisines, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandsApi.getBrandCuisinesBrandsCuisinesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brands.
         * @summary Get Brands
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandsBrandsGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBrand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandsBrandsGet(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandsApi.getBrandsBrandsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a cuisine operation benchmark.
         * @summary Get Cuisine Operation Benchmark
         * @param {string} brandId 
         * @param {string} cuisine 
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCuisineOperationBenchmarkBrandsCuisineOperationBenchmarkGet(brandId: string, cuisine: string, city?: string, areas?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CuisineOperationBenchmark>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCuisineOperationBenchmarkBrandsCuisineOperationBenchmarkGet(brandId, cuisine, city, areas, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandsApi.getCuisineOperationBenchmarkBrandsCuisineOperationBenchmarkGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get popular brands.
         * @summary Get Popular Brands
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [cuisines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopularBrandsBrandsPopularGet(page?: number, pageSize?: number, cuisines?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponsePopularBrand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopularBrandsBrandsPopularGet(page, pageSize, cuisines, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandsApi.getPopularBrandsBrandsPopularGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BrandsApi - factory interface
 * @export
 */
export const BrandsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandsApiFp(configuration)
    return {
        /**
         * Get a brand by name.
         * @summary Get Avg Price By Month
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvgPriceByMonthBrandsAvgPriceByMonthGet(city?: string, areas?: Array<string>, cuisine?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AvgPriceByMonth>> {
            return localVarFp.getAvgPriceByMonthBrandsAvgPriceByMonthGet(city, areas, cuisine, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a brand by name.
         * @summary Get Brand
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBrandsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Brand> {
            return localVarFp.getBrandBrandsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a brand by name.
         * @summary Get Brand By Name
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [city] 
         * @param {string} [area] 
         * @param {string} [cuisine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandByNameBrandsSearchGet(page?: number, pageSize?: number, name?: string, city?: string, area?: string, cuisine?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBrand> {
            return localVarFp.getBrandByNameBrandsSearchGet(page, pageSize, name, city, area, cuisine, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a brand list by cuisines.
         * @summary Get Brand Cuisines
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [cuisines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCuisinesBrandsCuisinesGet(page?: number, pageSize?: number, cuisines?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBrand> {
            return localVarFp.getBrandCuisinesBrandsCuisinesGet(page, pageSize, cuisines, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brands.
         * @summary Get Brands
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsBrandsGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBrand> {
            return localVarFp.getBrandsBrandsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a cuisine operation benchmark.
         * @summary Get Cuisine Operation Benchmark
         * @param {string} brandId 
         * @param {string} cuisine 
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuisineOperationBenchmarkBrandsCuisineOperationBenchmarkGet(brandId: string, cuisine: string, city?: string, areas?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<CuisineOperationBenchmark> {
            return localVarFp.getCuisineOperationBenchmarkBrandsCuisineOperationBenchmarkGet(brandId, cuisine, city, areas, options).then((request) => request(axios, basePath));
        },
        /**
         * Get popular brands.
         * @summary Get Popular Brands
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [cuisines] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopularBrandsBrandsPopularGet(page?: number, pageSize?: number, cuisines?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponsePopularBrand> {
            return localVarFp.getPopularBrandsBrandsPopularGet(page, pageSize, cuisines, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandsApi - object-oriented interface
 * @export
 * @class BrandsApi
 * @extends {BaseAPI}
 */
export class BrandsApi extends BaseAPI {
    /**
     * Get a brand by name.
     * @summary Get Avg Price By Month
     * @param {string} [city] 
     * @param {Array<string>} [areas] 
     * @param {string} [cuisine] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public getAvgPriceByMonthBrandsAvgPriceByMonthGet(city?: string, areas?: Array<string>, cuisine?: string, options?: RawAxiosRequestConfig) {
        return BrandsApiFp(this.configuration).getAvgPriceByMonthBrandsAvgPriceByMonthGet(city, areas, cuisine, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a brand by name.
     * @summary Get Brand
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public getBrandBrandsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return BrandsApiFp(this.configuration).getBrandBrandsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a brand by name.
     * @summary Get Brand By Name
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [name] 
     * @param {string} [city] 
     * @param {string} [area] 
     * @param {string} [cuisine] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public getBrandByNameBrandsSearchGet(page?: number, pageSize?: number, name?: string, city?: string, area?: string, cuisine?: string, options?: RawAxiosRequestConfig) {
        return BrandsApiFp(this.configuration).getBrandByNameBrandsSearchGet(page, pageSize, name, city, area, cuisine, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a brand list by cuisines.
     * @summary Get Brand Cuisines
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {Array<string>} [cuisines] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public getBrandCuisinesBrandsCuisinesGet(page?: number, pageSize?: number, cuisines?: Array<string>, options?: RawAxiosRequestConfig) {
        return BrandsApiFp(this.configuration).getBrandCuisinesBrandsCuisinesGet(page, pageSize, cuisines, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brands.
     * @summary Get Brands
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public getBrandsBrandsGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return BrandsApiFp(this.configuration).getBrandsBrandsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a cuisine operation benchmark.
     * @summary Get Cuisine Operation Benchmark
     * @param {string} brandId 
     * @param {string} cuisine 
     * @param {string} [city] 
     * @param {Array<string>} [areas] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public getCuisineOperationBenchmarkBrandsCuisineOperationBenchmarkGet(brandId: string, cuisine: string, city?: string, areas?: Array<string>, options?: RawAxiosRequestConfig) {
        return BrandsApiFp(this.configuration).getCuisineOperationBenchmarkBrandsCuisineOperationBenchmarkGet(brandId, cuisine, city, areas, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get popular brands.
     * @summary Get Popular Brands
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [cuisines] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public getPopularBrandsBrandsPopularGet(page?: number, pageSize?: number, cuisines?: string, options?: RawAxiosRequestConfig) {
        return BrandsApiFp(this.configuration).getPopularBrandsBrandsPopularGet(page, pageSize, cuisines, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Expose Prometheus metrics.
         * @summary Metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsMetricsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Expose Prometheus metrics.
         * @summary Metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metricsMetricsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metricsMetricsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.metricsMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Expose Prometheus metrics.
         * @summary Metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.metricsMetricsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Expose Prometheus metrics.
     * @summary Metrics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public metricsMetricsGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).metricsMetricsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MarketAnalysisApi - axios parameter creator
 * @export
 */
export const MarketAnalysisApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get radar of a branch.
         * @summary Get Restaurants Radar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestaurantsRadarMarketRestaurantsRadarGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market/restaurants-radar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List competitors of a branch.
         * @summary List Competitors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompetitorsMarketCompetitorsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market/competitors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketAnalysisApi - functional programming interface
 * @export
 */
export const MarketAnalysisApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketAnalysisApiAxiosParamCreator(configuration)
    return {
        /**
         * Get radar of a branch.
         * @summary Get Restaurants Radar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRestaurantsRadarMarketRestaurantsRadarGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseAny>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRestaurantsRadarMarketRestaurantsRadarGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketAnalysisApi.getRestaurantsRadarMarketRestaurantsRadarGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List competitors of a branch.
         * @summary List Competitors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCompetitorsMarketCompetitorsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseAny>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCompetitorsMarketCompetitorsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketAnalysisApi.listCompetitorsMarketCompetitorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MarketAnalysisApi - factory interface
 * @export
 */
export const MarketAnalysisApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketAnalysisApiFp(configuration)
    return {
        /**
         * Get radar of a branch.
         * @summary Get Restaurants Radar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestaurantsRadarMarketRestaurantsRadarGet(options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseAny> {
            return localVarFp.getRestaurantsRadarMarketRestaurantsRadarGet(options).then((request) => request(axios, basePath));
        },
        /**
         * List competitors of a branch.
         * @summary List Competitors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompetitorsMarketCompetitorsGet(options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseAny> {
            return localVarFp.listCompetitorsMarketCompetitorsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarketAnalysisApi - object-oriented interface
 * @export
 * @class MarketAnalysisApi
 * @extends {BaseAPI}
 */
export class MarketAnalysisApi extends BaseAPI {
    /**
     * Get radar of a branch.
     * @summary Get Restaurants Radar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketAnalysisApi
     */
    public getRestaurantsRadarMarketRestaurantsRadarGet(options?: RawAxiosRequestConfig) {
        return MarketAnalysisApiFp(this.configuration).getRestaurantsRadarMarketRestaurantsRadarGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List competitors of a branch.
     * @summary List Competitors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketAnalysisApi
     */
    public listCompetitorsMarketCompetitorsGet(options?: RawAxiosRequestConfig) {
        return MarketAnalysisApiFp(this.configuration).listCompetitorsMarketCompetitorsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeApi - axios parameter creator
 * @export
 */
export const MeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get brands with client id.
         * @summary Get Brands
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsMeBrandsGet: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/me/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeApi - functional programming interface
 * @export
 */
export const MeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeApiAxiosParamCreator(configuration)
    return {
        /**
         * Get brands with client id.
         * @summary Get Brands
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandsMeBrandsGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBrand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandsMeBrandsGet(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.getBrandsMeBrandsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeApi - factory interface
 * @export
 */
export const MeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeApiFp(configuration)
    return {
        /**
         * Get brands with client id.
         * @summary Get Brands
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsMeBrandsGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBrand> {
            return localVarFp.getBrandsMeBrandsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeApi - object-oriented interface
 * @export
 * @class MeApi
 * @extends {BaseAPI}
 */
export class MeApi extends BaseAPI {
    /**
     * Get brands with client id.
     * @summary Get Brands
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public getBrandsMeBrandsGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).getBrandsMeBrandsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MenuItemsApi - axios parameter creator
 * @export
 */
export const MenuItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get menu items by branch.
         * @summary Get Menu Items By Branch
         * @param {string} branchId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuItemsByBranchMenuItemsByBranchGet: async (branchId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'branchId' is not null or undefined
            assertParamExists('getMenuItemsByBranchMenuItemsByBranchGet', 'branchId', branchId)
            const localVarPath = `/menu-items/by-branch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (branchId !== undefined) {
                localVarQueryParameter['branch_id'] = branchId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get menu items of a branch.
         * @summary Get Menu Items
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuItemsMenuItemsGet: async (city?: string, areas?: Array<string>, cuisine?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/menu-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (areas) {
                localVarQueryParameter['areas'] = areas;
            }

            if (cuisine !== undefined) {
                localVarQueryParameter['cuisine'] = cuisine;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get popular menu items.
         * @summary Get Popular Menu Items
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopularMenuItemsMenuItemsPopularGet: async (page?: number, pageSize?: number, city?: string, areas?: Array<string>, cuisine?: string, minPrice?: number, maxPrice?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/menu-items/popular`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (areas) {
                localVarQueryParameter['areas'] = areas;
            }

            if (cuisine !== undefined) {
                localVarQueryParameter['cuisine'] = cuisine;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['min_price'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['max_price'] = maxPrice;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get unique menu items.
         * @summary Get Unique Menu Items
         * @param {string} brandId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniqueMenuItemsMenuItemsUniqueGet: async (brandId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getUniqueMenuItemsMenuItemsUniqueGet', 'brandId', brandId)
            const localVarPath = `/menu-items/unique`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (brandId !== undefined) {
                localVarQueryParameter['brand_id'] = brandId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search menu items.
         * @summary Search Menu Items
         * @param {string} [term] 
         * @param {string} [city] 
         * @param {string} [area] 
         * @param {string} [cuisine] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMenuItemsMenuItemsSearchGet: async (term?: string, city?: string, area?: string, cuisine?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/menu-items/search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (cuisine !== undefined) {
                localVarQueryParameter['cuisine'] = cuisine;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MenuItemsApi - functional programming interface
 * @export
 */
export const MenuItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MenuItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get menu items by branch.
         * @summary Get Menu Items By Branch
         * @param {string} branchId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMenuItemsByBranchMenuItemsByBranchGet(branchId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseMenuItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMenuItemsByBranchMenuItemsByBranchGet(branchId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MenuItemsApi.getMenuItemsByBranchMenuItemsByBranchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get menu items of a branch.
         * @summary Get Menu Items
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMenuItemsMenuItemsGet(city?: string, areas?: Array<string>, cuisine?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseMenuItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMenuItemsMenuItemsGet(city, areas, cuisine, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MenuItemsApi.getMenuItemsMenuItemsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get popular menu items.
         * @summary Get Popular Menu Items
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopularMenuItemsMenuItemsPopularGet(page?: number, pageSize?: number, city?: string, areas?: Array<string>, cuisine?: string, minPrice?: number, maxPrice?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponsePopularMenuItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopularMenuItemsMenuItemsPopularGet(page, pageSize, city, areas, cuisine, minPrice, maxPrice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MenuItemsApi.getPopularMenuItemsMenuItemsPopularGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get unique menu items.
         * @summary Get Unique Menu Items
         * @param {string} brandId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUniqueMenuItemsMenuItemsUniqueGet(brandId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseUniqueMenuItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUniqueMenuItemsMenuItemsUniqueGet(brandId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MenuItemsApi.getUniqueMenuItemsMenuItemsUniqueGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search menu items.
         * @summary Search Menu Items
         * @param {string} [term] 
         * @param {string} [city] 
         * @param {string} [area] 
         * @param {string} [cuisine] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchMenuItemsMenuItemsSearchGet(term?: string, city?: string, area?: string, cuisine?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseMenuItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchMenuItemsMenuItemsSearchGet(term, city, area, cuisine, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MenuItemsApi.searchMenuItemsMenuItemsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MenuItemsApi - factory interface
 * @export
 */
export const MenuItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MenuItemsApiFp(configuration)
    return {
        /**
         * Get menu items by branch.
         * @summary Get Menu Items By Branch
         * @param {string} branchId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuItemsByBranchMenuItemsByBranchGet(branchId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseMenuItem> {
            return localVarFp.getMenuItemsByBranchMenuItemsByBranchGet(branchId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get menu items of a branch.
         * @summary Get Menu Items
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenuItemsMenuItemsGet(city?: string, areas?: Array<string>, cuisine?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseMenuItem> {
            return localVarFp.getMenuItemsMenuItemsGet(city, areas, cuisine, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get popular menu items.
         * @summary Get Popular Menu Items
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [city] 
         * @param {Array<string>} [areas] 
         * @param {string} [cuisine] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopularMenuItemsMenuItemsPopularGet(page?: number, pageSize?: number, city?: string, areas?: Array<string>, cuisine?: string, minPrice?: number, maxPrice?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponsePopularMenuItem> {
            return localVarFp.getPopularMenuItemsMenuItemsPopularGet(page, pageSize, city, areas, cuisine, minPrice, maxPrice, options).then((request) => request(axios, basePath));
        },
        /**
         * Get unique menu items.
         * @summary Get Unique Menu Items
         * @param {string} brandId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniqueMenuItemsMenuItemsUniqueGet(brandId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseUniqueMenuItem> {
            return localVarFp.getUniqueMenuItemsMenuItemsUniqueGet(brandId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Search menu items.
         * @summary Search Menu Items
         * @param {string} [term] 
         * @param {string} [city] 
         * @param {string} [area] 
         * @param {string} [cuisine] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMenuItemsMenuItemsSearchGet(term?: string, city?: string, area?: string, cuisine?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseMenuItem> {
            return localVarFp.searchMenuItemsMenuItemsSearchGet(term, city, area, cuisine, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MenuItemsApi - object-oriented interface
 * @export
 * @class MenuItemsApi
 * @extends {BaseAPI}
 */
export class MenuItemsApi extends BaseAPI {
    /**
     * Get menu items by branch.
     * @summary Get Menu Items By Branch
     * @param {string} branchId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuItemsApi
     */
    public getMenuItemsByBranchMenuItemsByBranchGet(branchId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MenuItemsApiFp(this.configuration).getMenuItemsByBranchMenuItemsByBranchGet(branchId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get menu items of a branch.
     * @summary Get Menu Items
     * @param {string} [city] 
     * @param {Array<string>} [areas] 
     * @param {string} [cuisine] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuItemsApi
     */
    public getMenuItemsMenuItemsGet(city?: string, areas?: Array<string>, cuisine?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MenuItemsApiFp(this.configuration).getMenuItemsMenuItemsGet(city, areas, cuisine, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get popular menu items.
     * @summary Get Popular Menu Items
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [city] 
     * @param {Array<string>} [areas] 
     * @param {string} [cuisine] 
     * @param {number} [minPrice] 
     * @param {number} [maxPrice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuItemsApi
     */
    public getPopularMenuItemsMenuItemsPopularGet(page?: number, pageSize?: number, city?: string, areas?: Array<string>, cuisine?: string, minPrice?: number, maxPrice?: number, options?: RawAxiosRequestConfig) {
        return MenuItemsApiFp(this.configuration).getPopularMenuItemsMenuItemsPopularGet(page, pageSize, city, areas, cuisine, minPrice, maxPrice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get unique menu items.
     * @summary Get Unique Menu Items
     * @param {string} brandId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuItemsApi
     */
    public getUniqueMenuItemsMenuItemsUniqueGet(brandId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MenuItemsApiFp(this.configuration).getUniqueMenuItemsMenuItemsUniqueGet(brandId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search menu items.
     * @summary Search Menu Items
     * @param {string} [term] 
     * @param {string} [city] 
     * @param {string} [area] 
     * @param {string} [cuisine] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuItemsApi
     */
    public searchMenuItemsMenuItemsSearchGet(term?: string, city?: string, area?: string, cuisine?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MenuItemsApiFp(this.configuration).searchMenuItemsMenuItemsSearchGet(term, city, area, cuisine, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MetaApi - axios parameter creator
 * @export
 */
export const MetaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get areas.
         * @summary Get Areas
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAreasMetaAreasGet: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/meta/areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get areas with cities.
         * @summary Get Areas V2
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAreasV2MetaV2AreasGet: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/meta/v2/areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get cities.
         * @summary Get City
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityMetaCitiesGet: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/meta/cities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get cuisines.
         * @summary Get Cuisines
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuisinesMetaCuisinesGet: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/meta/cuisines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get city by name.
         * @summary Search City By Name
         * @param {string} term 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCityByNameMetaSearchCityGet: async (term: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'term' is not null or undefined
            assertParamExists('searchCityByNameMetaSearchCityGet', 'term', term)
            const localVarPath = `/meta/search/city/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetaApi - functional programming interface
 * @export
 */
export const MetaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetaApiAxiosParamCreator(configuration)
    return {
        /**
         * Get areas.
         * @summary Get Areas
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAreasMetaAreasGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseStr>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAreasMetaAreasGet(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.getAreasMetaAreasGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get areas with cities.
         * @summary Get Areas V2
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAreasV2MetaV2AreasGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseAreaWithCity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAreasV2MetaV2AreasGet(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.getAreasV2MetaV2AreasGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get cities.
         * @summary Get City
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCityMetaCitiesGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseStr>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCityMetaCitiesGet(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.getCityMetaCitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get cuisines.
         * @summary Get Cuisines
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCuisinesMetaCuisinesGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseStr>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCuisinesMetaCuisinesGet(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.getCuisinesMetaCuisinesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get city by name.
         * @summary Search City By Name
         * @param {string} term 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCityByNameMetaSearchCityGet(term: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseStr>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCityByNameMetaSearchCityGet(term, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetaApi.searchCityByNameMetaSearchCityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetaApi - factory interface
 * @export
 */
export const MetaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetaApiFp(configuration)
    return {
        /**
         * Get areas.
         * @summary Get Areas
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAreasMetaAreasGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseStr> {
            return localVarFp.getAreasMetaAreasGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get areas with cities.
         * @summary Get Areas V2
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAreasV2MetaV2AreasGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseAreaWithCity> {
            return localVarFp.getAreasV2MetaV2AreasGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get cities.
         * @summary Get City
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityMetaCitiesGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseStr> {
            return localVarFp.getCityMetaCitiesGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get cuisines.
         * @summary Get Cuisines
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCuisinesMetaCuisinesGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseStr> {
            return localVarFp.getCuisinesMetaCuisinesGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get city by name.
         * @summary Search City By Name
         * @param {string} term 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCityByNameMetaSearchCityGet(term: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseStr> {
            return localVarFp.searchCityByNameMetaSearchCityGet(term, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetaApi - object-oriented interface
 * @export
 * @class MetaApi
 * @extends {BaseAPI}
 */
export class MetaApi extends BaseAPI {
    /**
     * Get areas.
     * @summary Get Areas
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getAreasMetaAreasGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MetaApiFp(this.configuration).getAreasMetaAreasGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get areas with cities.
     * @summary Get Areas V2
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getAreasV2MetaV2AreasGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MetaApiFp(this.configuration).getAreasV2MetaV2AreasGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get cities.
     * @summary Get City
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getCityMetaCitiesGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MetaApiFp(this.configuration).getCityMetaCitiesGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get cuisines.
     * @summary Get Cuisines
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getCuisinesMetaCuisinesGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MetaApiFp(this.configuration).getCuisinesMetaCuisinesGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get city by name.
     * @summary Search City By Name
     * @param {string} term 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public searchCityByNameMetaSearchCityGet(term: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return MetaApiFp(this.configuration).searchCityByNameMetaSearchCityGet(term, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceApi - axios parameter creator
 * @export
 */
export const ServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the service information.
         * @summary Get Service Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceInfoInfoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks the service status. Returns a detailed status report of all service dependencies.
         * @summary Get Service Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatusHealthcheckGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthcheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceApi - functional programming interface
 * @export
 */
export const ServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the service information.
         * @summary Get Service Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceInfoInfoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceInfoInfoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceApi.getServiceInfoInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks the service status. Returns a detailed status report of all service dependencies.
         * @summary Get Service Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceStatusHealthcheckGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceStatusHealthcheckGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceApi.getServiceStatusHealthcheckGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceApi - factory interface
 * @export
 */
export const ServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceApiFp(configuration)
    return {
        /**
         * Returns the service information.
         * @summary Get Service Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceInfoInfoGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getServiceInfoInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Checks the service status. Returns a detailed status report of all service dependencies.
         * @summary Get Service Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatusHealthcheckGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getServiceStatusHealthcheckGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
export class ServiceApi extends BaseAPI {
    /**
     * Returns the service information.
     * @summary Get Service Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getServiceInfoInfoGet(options?: RawAxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getServiceInfoInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks the service status. Returns a detailed status report of all service dependencies.
     * @summary Get Service Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getServiceStatusHealthcheckGet(options?: RawAxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getServiceStatusHealthcheckGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WatchlistApi - axios parameter creator
 * @export
 */
export const WatchlistApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a brand to a client\'s watchlist.  Args:     request: FastAPI request object containing user country     brand_id: ID of the brand to add to the watchlist
         * @summary Add Brand To Watchlist
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBrandToWatchlistWatchlistBrandIdPost: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('addBrandToWatchlistWatchlistBrandIdPost', 'brandId', brandId)
            const localVarPath = `/watchlist/{brand_id}`
                .replace(`{${"brand_id"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated brands from a client\'s watchlist.  Args:     request: FastAPI request object containing user country     page: Page number (1-based indexing)     page_size: Number of items per page  Returns:     PaginatedResponse containing the requested page of brands
         * @summary Get Watchlist
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistWatchlistGet: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/watchlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a brand from a client\'s watchlist.  Args:     request: FastAPI request object containing user country     brand_id: ID of the brand to remove from the watchlist
         * @summary Remove Brand From Watchlist
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBrandFromWatchlistWatchlistBrandIdDelete: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('removeBrandFromWatchlistWatchlistBrandIdDelete', 'brandId', brandId)
            const localVarPath = `/watchlist/{brand_id}`
                .replace(`{${"brand_id"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WatchlistApi - functional programming interface
 * @export
 */
export const WatchlistApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WatchlistApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a brand to a client\'s watchlist.  Args:     request: FastAPI request object containing user country     brand_id: ID of the brand to add to the watchlist
         * @summary Add Brand To Watchlist
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBrandToWatchlistWatchlistBrandIdPost(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBrandToWatchlistWatchlistBrandIdPost(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WatchlistApi.addBrandToWatchlistWatchlistBrandIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated brands from a client\'s watchlist.  Args:     request: FastAPI request object containing user country     page: Page number (1-based indexing)     page_size: Number of items per page  Returns:     PaginatedResponse containing the requested page of brands
         * @summary Get Watchlist
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWatchlistWatchlistGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseBrand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWatchlistWatchlistGet(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WatchlistApi.getWatchlistWatchlistGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a brand from a client\'s watchlist.  Args:     request: FastAPI request object containing user country     brand_id: ID of the brand to remove from the watchlist
         * @summary Remove Brand From Watchlist
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeBrandFromWatchlistWatchlistBrandIdDelete(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeBrandFromWatchlistWatchlistBrandIdDelete(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WatchlistApi.removeBrandFromWatchlistWatchlistBrandIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WatchlistApi - factory interface
 * @export
 */
export const WatchlistApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WatchlistApiFp(configuration)
    return {
        /**
         * Add a brand to a client\'s watchlist.  Args:     request: FastAPI request object containing user country     brand_id: ID of the brand to add to the watchlist
         * @summary Add Brand To Watchlist
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBrandToWatchlistWatchlistBrandIdPost(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.addBrandToWatchlistWatchlistBrandIdPost(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated brands from a client\'s watchlist.  Args:     request: FastAPI request object containing user country     page: Page number (1-based indexing)     page_size: Number of items per page  Returns:     PaginatedResponse containing the requested page of brands
         * @summary Get Watchlist
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistWatchlistGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseBrand> {
            return localVarFp.getWatchlistWatchlistGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a brand from a client\'s watchlist.  Args:     request: FastAPI request object containing user country     brand_id: ID of the brand to remove from the watchlist
         * @summary Remove Brand From Watchlist
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBrandFromWatchlistWatchlistBrandIdDelete(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.removeBrandFromWatchlistWatchlistBrandIdDelete(brandId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WatchlistApi - object-oriented interface
 * @export
 * @class WatchlistApi
 * @extends {BaseAPI}
 */
export class WatchlistApi extends BaseAPI {
    /**
     * Add a brand to a client\'s watchlist.  Args:     request: FastAPI request object containing user country     brand_id: ID of the brand to add to the watchlist
     * @summary Add Brand To Watchlist
     * @param {string} brandId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistApi
     */
    public addBrandToWatchlistWatchlistBrandIdPost(brandId: string, options?: RawAxiosRequestConfig) {
        return WatchlistApiFp(this.configuration).addBrandToWatchlistWatchlistBrandIdPost(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated brands from a client\'s watchlist.  Args:     request: FastAPI request object containing user country     page: Page number (1-based indexing)     page_size: Number of items per page  Returns:     PaginatedResponse containing the requested page of brands
     * @summary Get Watchlist
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistApi
     */
    public getWatchlistWatchlistGet(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return WatchlistApiFp(this.configuration).getWatchlistWatchlistGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a brand from a client\'s watchlist.  Args:     request: FastAPI request object containing user country     brand_id: ID of the brand to remove from the watchlist
     * @summary Remove Brand From Watchlist
     * @param {string} brandId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistApi
     */
    public removeBrandFromWatchlistWatchlistBrandIdDelete(brandId: string, options?: RawAxiosRequestConfig) {
        return WatchlistApiFp(this.configuration).removeBrandFromWatchlistWatchlistBrandIdDelete(brandId, options).then((request) => request(this.axios, this.basePath));
    }
}



